<script>
import MvContainer from '@/components/MvContainer/index.vue'
import MvDialog from '@/components/MvDialog/index.vue'
import { intros, cooperationCases } from '@/utils/intros'

export default {
  name: 'MvFooter',
  components: { MvDialog, MvContainer },
  data() {
    return {
      menus: [
        {
          title: '关于我们',
          items: [
            {
              name: '企业简介',
              url: '/about'
            },
            {
              name: '资质荣誉',
              url: ''
            },
            {
              name: '企业文化',
              url: ''
            },
            {
              name: '团队风采',
              url: ''
            }
          ]
        },
        {
          title: '主营业务',
          type: 'mainBus',
          items: [
            {
              name: '营业性演出',
              url: 'yyxyc',
              model: 'dialog'
            },
            {
              name: '演出经纪',
              url: 'ycjjyw',
              model: 'dialog'
            },
            {
              name: '票务代理服务',
              url: 'pwdlfw',
              model: 'dialog'
            }
          ]
        },
        {
          title: '合作案例',
          type: 'case',
          items: [
            {
              name: '“非遗过大年”—山南篇',
              url: 1
            },
            {
              name: '林芝第二十二届桃花旅游文化节巴宜区分会场',
              url: 2
            },
            {
              name: '幸福西藏•扎西德勒“文化惠民工程” 罗布林卡景区驻场演出',
              url: 3
            },
            {
              name: '“嘎拉村村民的心声”——“感恩总书记・共建新家园”巴宜区庆祝西藏自治区成立六十周年主题文艺演出',
              url: 4
            },
            {
              name: '夏帕列文创',
              url: 5
            }
          ]
        }
      ],
      introVisible: false,
      introCode: 'yyxyc',
      caseCurrent: 0,
      caseVisible: false,
      cases: cooperationCases
    }
  },
  computed: {
    introName() {
      return intros[this.introCode].name
    },
    introContent() {
      return intros[this.introCode].content
    },
    currentCase() {
      return this.cases[this.caseCurrent]
    }
  },
  methods: {
    goto(path, model, type) {
      if (path) {
        if (type === 'case') {
          this.caseCurrent = this.cases.findIndex(item => item.id === path)
          this.caseVisible = true
          return
        }
        if (model === 'dialog') {
          this.introCode = path
          this.introVisible = true
        } else {
          this.$router.push({
            path: path
          })
        }
      } else {
        this.$toast.warning('暂未开通，敬请期待')
      }
    }
  }
}
</script>

<template>
  <mv-container
    :header="false"
    bg="#1D1C19"
    bg-mode="string"
    content-style="padding-bottom: 0;"
  >
    <div class="content">
      <div v-for="item in menus" :key="item.title" class="group">
        <div class="title">{{ item.title }}</div>
        <div class="list">
          <div v-for="i in item.items" :key="i.name" class="item" @click="goto(i.url, i.model, item.type)">
            {{ i.name }}
          </div>
        </div>
      </div>
      <div class="group">
        <div class="title">联系我们</div>
        <div class="list">
          <div class="item">
            <div class="icon">
              <img :src="require('@/assets/ic_mobile.png')">
            </div>
            17711908519、15348994949
          </div>
          <div class="item">
            <div class="icon">
              <img :src="require('@/assets/ic_email.png')">
            </div>
            17711908519@163.com
          </div>
          <div class="item">
            <div class="icon">
              <img :src="require('@/assets/ic_address.png')">
            </div>
            西藏自治区拉萨市城关区罗布林卡路3号6号楼
          </div>
        </div>
      </div>
      <div class="group" style="display: flex; flex-direction: column; align-items: flex-end;">
        <div
          class="qrcode-box"
        >
          <div class="title">扫码添加微信</div>
          <div class="qrcode">
            <img src="/static/wechat.png" style="width: 100%; height: 100%;">
          </div>
        </div>

      </div>
    </div>
    <div class="beian">
      西藏演艺有限责任公司/<a href="https://beian.miit.gov.cn/" target="_blank">藏ICP备2024002077号-2</a>
    </div>

    <mv-dialog
      :visible.sync="introVisible"
      :title="introName"
      :custom-body-style="{
        padding: '0 20px'
      }"
    >
      <div class="dialog-content" v-html="introContent" />
    </mv-dialog>

    <mv-dialog :visible.sync="caseVisible" :title="currentCase.name">
      <div v-if="currentCase.content" class="dialog-content" v-html="currentCase.content" />
      <div v-if="currentCase.videos && currentCase.videos.length" class="video-box">
        <video v-for="(video,index) in currentCase.videos" :key="index" controls :src="video" />
      </div>
    </mv-dialog>

  </mv-container>
</template>

<style scoped lang="scss">
.content {
  padding: 22px 0;
  display: flex;

  .title {
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 21px;
  }

  .group {
    flex: 1;
    cursor: pointer;
  }

  .list {
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;

    .item {
      font-weight: 400;
      font-size: 13px;
      color: rgb(255, 255, 255, 0.7);
      line-height: 17px;
      display: flex;
      align-items: center;
      gap: 5px;

      .icon {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .item:hover {
      color: white;
    }
  }

  .qrcode-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .qrcode {
    width: 119px;
    height: 119px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;

    img {
      width: 96px;
      height: 96px;
      background: #B4BCCB;
    }
  }
}

.beian ,.beian a{
  background-color: #0D0E0D;
  font-weight: 400;
  font-size: 14px;
  color: #A1A1A1;
  line-height: 19px;
  padding: 18px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

a {
  text-decoration: none;
}

.dialog-content {
  white-space: pre-wrap;
  font-weight: 400;
  font-size: 15px;
  color: #9E9E9E;
  line-height: 22px;
}

.video-box {
  width: 100%;

  video {
    width: 100%;
    height: 500px;
  }
}

::v-deep img {
  max-width: 100%;
}
</style>
